var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "cart-block__item grid-column-2 mobile-column-1",
      attrs: { "data-id": _vm.item.ID }
    },
    [
      _c("div", { staticClass: "grid-column-2 grid-with-gap" }, [
        _c("span", { staticClass: "cart-item-image" }, [
          _c("img", {
            attrs: { src: _vm.item.detailPictureSrc, alt: _vm.item.name }
          })
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "cart-item-title" }, [
          _c("a", { attrs: { href: _vm.item.detailPageUrl } }, [
            _vm._v(_vm._s(_vm.item.name))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "grid-column-2" }, [
        _c("span", { staticClass: "cart-item-text" }, [
          _vm._v(_vm._s(_vm.item.price) + "р")
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "cart-item-text" }, [
          _vm._v(_vm._s(_vm.item.sumValue) + "р")
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "cart-item-text" }, [
          _c(
            "a",
            {
              staticClass: "like-button",
              attrs: { href: "#" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.decrement()
                }
              }
            },
            [_vm._v("-")]
          ),
          _vm._v(
            "\n            " + _vm._s(_vm.item.quantity) + "\n            "
          ),
          _c(
            "a",
            {
              staticClass: "like-button",
              attrs: { href: "#" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.increment()
                }
              }
            },
            [_vm._v("+")]
          )
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "cart-item-text" }, [
          _c("a", {
            staticClass: "cross delete",
            attrs: { href: "#" },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.remove($event)
              }
            }
          })
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }